import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { usersApi } from '@/services/rest/apiInstances';

export const fetchUsersList = createAsyncThunk(
    'users/fetchUsersList',
    async (clientId?: string | null) => {
        try {
            const data = clientId
                ? await usersApi.listUsers({ headers: { 'X-Client-Id': clientId } })
                : await usersApi.listUsers();
            return data.data;
        } catch (error: any) {
            return error.data;
        }
    },
);

export interface IUsersState {
    isPending: boolean;
    usersList: any[];
    isCreateUserModalOpen: boolean;
    isEditUserModalOpen: boolean;
    userDataForEditing: any;
    clientId?: any;
    errors?: any;
}

const initialState: IUsersState = {
    isPending: false,
    isCreateUserModalOpen: false,
    isEditUserModalOpen: false,
    userDataForEditing: null,
    usersList: [],
    clientId: undefined,
    errors: undefined,
};

export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        showCreateUserModal: (state, action?: PayloadAction<any>) => {
            state.isCreateUserModalOpen = true;
            state.clientId = action?.payload || undefined;
        },
        hideCreateUserModal: (state) => {
            state.isCreateUserModalOpen = false;
        },
        showEditUserModal: (state, action: PayloadAction<any>) => {
            state.isEditUserModalOpen = true;
            state.userDataForEditing = action.payload.user;
            state.clientId = { clientId: action.payload.clientId };
        },
        hideEditUserModal: (state) => {
            state.isEditUserModalOpen = false;
            state.userDataForEditing = null;
            state.clientId = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsersList.pending, (state) => {
                state.isPending = true;
            })
            .addCase(fetchUsersList.rejected, (state, action) => {
                state.isPending = false;
                state.errors = action.error;
            })
            .addCase(fetchUsersList.fulfilled, (state, action) => {
                const users = action.payload;

                state.isPending = false;
                if (users) {
                    state.usersList = users;
                }
            });
    },
});

export const { showCreateUserModal, hideCreateUserModal, showEditUserModal, hideEditUserModal } =
    usersSlice.actions;

export default usersSlice.reducer;
